export default __webpack_public_path__ + "static/media/TM.9af9d8de.svg";